export default {"src":"/_next/static/media/spinner.2fe29829.svg","height":64,"width":64};